export { ReactComponent as Quote } from './svgs/quote.svg';
